export const GET_SUGGESTIONS_REQUEST = "GET_SUGGESTIONS_REQUEST";
export const GET_SUGGESTIONS_SUCCESS = "GET_SUGGESTIONS_SUCCESS";
export const GET_SUGGESTIONS_FAILURE = "GET_SUGGESTIONS_FAILURE";
